import { render } from "./FormCompletedPage.vue?vue&type=template&id=977b2dfc&scoped=true"
import script from "./FormCompletedPage.vue?vue&type=script&lang=js"
export * from "./FormCompletedPage.vue?vue&type=script&lang=js"

import "./FormCompletedPage.vue?vue&type=style&index=0&id=977b2dfc&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-977b2dfc"]])

export default __exports__